export default {
  // Access Groups
  rap_crm: 'مدیریت ارتباط با مشتری',
  rap_reportsRAP: 'گزارشات',
  rap_sms: 'پیامک',
  rap_webchat: 'وب‌چت',
  rap_qaqc: 'ارزیابی عملکرد',
  rap_fax: 'فکس',
  rap_videoConference: 'ویدئو کنفرانس',
  rap_userSettings: 'تنظیمات کاربری',
  rap_callcenter: 'مرکز تماس',
  rap_callSettings: 'تنظیمات تماس',
  rap_connectToCrm: 'اتصال به CRM',
  rap_ticketSettings: 'تنظیمات تیکت',
  // rap_navatelSupport: 'پشتیبانی نواتل'

  // Accesses
  rap_ci_companies: 'شرکت‌ها',
  rap_timeline: 'تاریخچه فعالیت‌ها',
  rap_ci_persons: 'اشخاص',
  rap_lead: 'سرنخ‌ها',
  rap_convert: 'تبدیل سرنخ به مخاطب',
  rap_deal: 'فرصت‌های فروش',
  rap_ticket: 'تیکت‌ها',
  rap_answer: 'پاسخ دادن',
  rap_change_status: 'تغییر وضعیت',
  rap_task: 'وظیفه‌ها',
  rap_comment: 'نظردهی',
  rap_invoice: 'فاکتور/پیش‌فاکتور',
  rap_invoice_settings: 'تنظیمات فاکتور',
  rap_product: 'محصولات',
  rap_add_product: 'اضافه کردن محصول',
  rap_inventory: 'انبار',
  rap_sms_contacts: 'دفترچه تلفن',
  rap_sms_single_send: 'ارسال تکی',
  rap_sms_group_send: 'ارسال گروهی',
  rap_sms_bulk_send: 'ارسال انبوه',
  rap_sms_p2p_send: 'ارسال متناظر',
  rap_sms_parametric_send: 'ارسال پارامتریک',
  rap_sms_developers_section: 'ویژه برنامه نویسان',
  rap_sms_messages_detail: 'گزارش ارسال',
  rap_sms_inbounds: 'گزارش دریافت',

  // Report گزارشات
  rap_call_logs: 'سوابق تماس',
  rap_call_report_unanswerd: 'وضعیت تماس',
  rap_operators_activity: 'عملکرد پاسخگویی کاربر',
  rap_call_records: 'رکورد مکالمات',
  rap_full_call_records: 'گزارش پیشرفته',
  rap_rating: 'نتایج نظر سنجی مکالمات',
  rap_call_scattering: 'نمودار پراکندگی تماس‌ها',
  rap_cost_log: 'نمودار تاریخچه هزینه‌ها',
  rap_customer_waiting: 'نمودار صبر مشتری',
  rap_call_report_missed: 'تماس‌های از دست‌رفته',

  // Monitoring مانیتورینگ
  rap_live_monitoring: 'والبرد',
  rap_wallboard: 'مانیتورینگ کاربران',

  // SMS پیامک
  rap_message_single: 'ارسال پیامک تکی',
  rap_message_group: 'ارسال گروهی',
  rap_message_bulk: 'ارسال انبوه',
  rap_message_send_report: 'گزارش ارسال',
  rap_message_receive_report: 'گزارش دریافت',
  rap_message_corresponding: 'ارسال پیامک متناظر',
  rap_message_otp: 'ویژه برنامه نویسان',
  rap_message_parametric: 'ارسال پیامک پارامتریک',
  rap_bulk_send: 'ارسال انبوه',
  rap_contact_add: 'افزودن مخاطب',
  rap_contact_delete: 'حذف مخاطب',
  rap_contact_report: 'گزارشات مخاطبین',
  rap_contact_update: 'ویرایش مخاطب',
  rap_contact_view: 'نمایش مخاطبین',
  rap_developers_section: 'ویژه برنامه نویسان',
  rap_add_group: 'افزودن گروه',
  rap_delete_group: 'حذف گروه',
  rap_edit_group: 'ویرایش گروه',
  rap_send_group: 'ارسال گروهی',
  rap_view_group: 'نمایش گروه',

  // Webchat وب‌چت
  rap_webchat_counter: 'پیشخوان',
  rap_webchat_declare_website: 'تعریف وب‌سایت',
  rap_webchat_operator_management: 'اپراتور‌ها',
  rap_webchat_department: 'تعریف دپارتمان‌ها',
  rap_webchat_personalization: 'تنظیمات و شخصی سازی',
  rap_webchat_chats: 'گفتگوها',

  // QAQC ارزیابی عملکرد
  rap_evaluations: 'ثبت ارزیابی عملکرد',
  rap_evaluation_report: 'گزارش عملکرد کاربران',

  // Fax فکس
  rap_fax_create: 'ایجاد فکس',
  rap_fax_send: 'ارسال فکس',
  rap_fax_sent_report: 'فکس‌های ارسالی',
  rap_fax_recv_report: 'فکس‌های دریافتی',

  // VideoConference ویدئو کنفرانس
  rap_conf_create_link: 'ایجاد لینک',
  rap_conf_report: 'گزارشات',

  // Call Settings تنظیمات تماس
  rap_call_forward: 'تعریف شماره کال فوروارد',
  rap_add_user: 'تعریف شماره کال فوروارد',
  rap_upload_voice: 'بارگذاری فایل صوتی',
  rap_queue: 'مدیریت صف',
  rap_ivr_menu: 'مدیریت IVR',
  rap_time_cond: 'تعیین شروط زمانی',
  rap_voicemail_management: 'مدیریت پیام‌های صوتی',
  rap_block_list: 'لیست سیاه',
  rap_destinations: 'مقصد تماس',
  rap_rating_call: 'نظر‌سنجی تماس',
  rap_record_call: 'ضبط مکالمات',

  // User Settings
  rap_role_management: 'مدیریت کاربران',
  rap_department: 'دپارتمان',
  rap_permission_management: 'مدیریت نقش‌ و دسترسی‌',
  rap_message_to_operator: 'ارسال پیام به کاربران',
  rap_whatsapp: 'واتساپ',
  rap_stream_record_sound: 'صوت رکوردهای تماس',

  // Connect to CRM
  rap_crm_authorized_numbers: 'تعریف شماره مجاز CRM',
  rap_crm_links: 'ساختار CRM',
  rap_crm_settings: 'لینک‌های اتصال به CRM',

  //automation
  rap_automation: 'اتوماسیون',
  rap_workflow: 'گردش‌کار',

  //setting
  rap_ticket_board: 'بوردها',
  rap_deleteBoard: 'حذف بورد',
  rap_editBoard: 'ویرایش بورد',
  rap_createBoard: 'افزودن بورد',
  rap_viewSettings: 'مشاهده تنظیمات',

  // Base Permissions
  rap_add: 'افزودن',
  rap_delete: 'حذف',
  rap_edit: 'ویرایش',
  rap_view: 'مشاهده',

  // Custom Permissions
  rap_assign: 'اختصاص',
  rap_convert_to_contact: 'تبدیل به مخاطب',
  rap_convert_to_invoice: 'تبدیل پیش‌فاکتور به فاکتور',
  rap_create_category: 'ایجاد دسته‌بندی',
  rap_delete_category: 'حذف دسته‌بندی',
  rap_edit_category: 'ویرایش دسته‌بندی',
  rap_report: 'گزارش',
  rap_upload: 'بارگذاری',
  rap_close: 'بستن',
  rap_delete_agent: 'حذف اپراتور',
  rap_invoke: 'ابطال',
  rap_add_pre_invoice: 'افزودن پیش‌فاکتور',
  rap_add_invoice: 'افزودن فاکتور',
  rap_add_and_edit: 'افزودن و ویرایش',
  rap_messaging_in_whatsapp: 'پیام‌رسانی در واتساپ',
  rap_whatsapp_settings: 'تنظیمات واتساپ',
  rap_stream_record_sound_view: 'پخش و دانلود صوت رکوردهای تماس',
  rap_title_options: 'ثبت، ویرایش و حذف عنوان‌های پیش‌فرض',

  // Policies
  rap_all: 'همه رکوردهای ماژول',
  rap_self: 'رکوردهای خود',
  rap_self_and_department_mates: 'رکوردهای خود و دپارتمان خود',
  rap_self_and_role_mates: 'رکوردهای خود و هم‌نقش خود در دپارتمان',
};
